<template>
  <div>
    <space v-if="error.serverError"></space>
    <div class="row">
      <div class="col-12 u-text-right">
        <!-- Export record to PDF (email or direct download) -->
        <div class="u-inline u-fill-width u-text-right" v-if="isSigned">
          <button class="btn-dark u-inline u-margin-right" v-on:click="email()">
            <loading-spinner v-show="loading.email"></loading-spinner>
            <span class="icon" v-show="!loading.email">
              <i class="fa-wrapper fa fa-envelope normal-icon pad-right"></i>
            </span>
            Email Record
          </button>
          <button class="btn-link u-inline" v-on:click="download()">
            <loading-spinner v-show="loading.download"></loading-spinner>
            <span class="icon" v-show="!loading.download">
              <i class="fa-wrapper fa fa-file-pdf normal-icon pad-right"></i>
            </span>
            Download Record
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <h6 class="font-light">Flight Details</h6>
      </div>
    </div>
    <div class="row">
      <table class="table bordered">
        <tbody>
          <tr>
            <th>
              Overall Result
            </th>
            <td>
              <record-repeat-icon v-bind:isRepeat="record.is_repeat">
              </record-repeat-icon>
              <status-tag
                v-bind:status="record.status"
                v-bind:label="record.result"
              >
              </status-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-12">
        <table class="table bordered">
          <tbody>
            <tr>
              <th>Date</th>
              <th v-if="items.length > 0">Aircraft</th>
              <th v-if="items.length > 0">Type</th>
            </tr>
            <tr>
              <td>{{ formatDate(record.date) }}</td>
              <td v-if="items.length > 0">{{ record.aircraft_identifier }}</td>
              <td v-if="items.length > 0">{{ record.aircraft_type }}</td>
            </tr>
          </tbody>
        </table>
        <table class="table bordered">
          <thead>
            <tr>
              <th v-for="(field, idx) in record.hours" v-bind:key="idx">
                {{ field.label | whitespace | titlecase }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-for="(field, idx) in record.hours" v-bind:key="idx">
                {{ field.value }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="items.length > 0" class="row">
      <div class="col-12">
        <h6 class="font-light">Competencies</h6>
        <table class="table bordered striped">
          <thead>
            <tr>
              <th colspan="2" class="u-text-left">Competency</th>
              <th>Grade</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" v-bind:key="item.id">
              <th>{{ item.competency_reference }}</th>
              <td class="u-text-left">{{ item.competency_name }}</td>
              <td>
                <item-status v-bind:item="item"></item-status>
              </td>
              <td>
                <item-reason-code v-bind:item="item"></item-reason-code>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h6 class="font-light">Comments</h6>
        <table class="table bordered">
          <tr>
            <td class="u-text-left">
              <p
                v-for="(line, idx) in record.comment.split('\n')"
                v-bind:key="idx"
              >
                {{ line }}
              </p>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { DateFormatter } from "@/functions/dateFormat.function";
import StatusTag from "@/components/StatusTag";
import ItemStatus from "@/components/records/ItemStatus";
import ItemReasonCode from "@/components/records/ItemReasonCode";
import LoadingSpinner from "@/components/LoadingSpinner";
import RecordRepeatIcon from "@/components/records/RecordRepeatIcon";
// Downloading files etc.
import RecordService from "@/services/records.service";
import { handleFileDownload } from "@/functions/handleFileDownload.function";
import { handleError } from "@/functions/handleError.function";

export default {
  name: "record-view",
  data: function() {
    return {
      loading: {
        download: false,
        email: false
      }
    };
  },
  components: {
    StatusTag,
    ItemStatus,
    ItemReasonCode,
    LoadingSpinner,
    RecordRepeatIcon
  },
  props: {
    record: {},
    items: {}
  },
  computed: {
    ...mapGetters("core", ["error"]),
    isSigned: function() {
      return (
        this.record.candidate_signature != "" &&
        this.record.instrcutor_signature != ""
      );
    }
  },
  methods: {
    formatDate: function(dateString) {
      return DateFormatter(dateString);
    },
    getField: function(field) {
      return this.record[field];
    },
    download: function() {
      RecordService.getPdf(this.record.id)
        .then(response => {
          this.loading.download = false;
          let link = handleFileDownload(response);
          link.click();
          setTimeout(() => {
            link.remove();
            window.URL.revokeObjectURL(link.href);
          }, 5000);
        })
        .catch(error => {
          this.loading.download = false;
          var data = handleError(error);
          this.$store.commit("core/setError", data);
        });
    },
    email: function() {
      this.loading.email = true;
      RecordService.getEmail(this.record.id)
        .then(() => {
          this.loading.email = false;
        })
        .catch(error => {
          this.loading.email = false;
          var data = handleError(error);
          this.$store.commit("core/setError", data);
        });
    }
  }
};
</script>
